/*eslint no-console: 0*/
import config from '../../../lib/config'
import PageMixins from '../../../components/_mixins/pages'
import ValidationMixins from '../../../components/_mixins/validation'
import MainService from '../../../services/main'

export default {
  name: 'verify-account-error',
  mixins: [PageMixins, ValidationMixins],
  props: ['email', 'showHomeLink'],
  components: {},
  data() {
    return {
      sendingRequest: false,
      requestSentError: '',
      resendCount: 0,
    }
  },
  mounted() {
    this.resendCount = 0
    this.requestSentError = ''
  },
  methods: {
    async resendConfirmation() {
      this.requestSentError = ''
      const email = this.email
      this.sendingRequest = true
      try {
        const data = await MainService.sendConfirmation({email})
        this.resendCount++
      } catch (e) {
        this.requestSentError = MainService.getFirstErrorMessage(e)
      }
      this.sendingRequest = false
    },
    backToSignIn() {
      this.showUserVerificationPrompt(false)
    }
  }
}
